var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.slices),function(slice,sliceIndex){return _c(slice.slice_type,{key:sliceIndex,tag:"component",attrs:{"slice":slice}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }